import { warn } from 'cc';
import Game from '../../Game';

namespace Storage {
    let enabled = true;
    let name: string = 'default';

    export function setEnabled(value: boolean) {
        enabled = value;
    }

    export function setName(newName: string) {
        name = newName;
    }
    export function getName(game: Game = Game.Instance): string {
        return name === 'default' ? game.config.gameID : name;
    }

    export function saveToLocal(key: string, data: Object, game: Game = Game.Instance) {
        if (!enabled) {
            return;
        }
        try {
            localStorage.setItem(`${getName(game)}/${key}`, JSON.stringify(data));
        } catch (error) {
            warn(error);
        }
    }

    export function forcedSaveToLocal(key: string, data: Object, game: Game = Game.Instance) {
        const flag = enabled;
        setEnabled(true);
        saveToLocal(key, data, game);
        setEnabled(flag);
    }

    export function loadFromLocal(key: string, game: Game = Game.Instance): any {
        if (!enabled) {
            return null;
        }
        try {
            return JSON.parse(localStorage.getItem(`${getName(game)}/${key}`));
        } catch (error) {
            warn(error);
            return null;
        }
    }

    export function forcedloadFromLocal(key: string, game: Game = Game.Instance) {
        const flag = enabled;
        setEnabled(true);
        const data = loadFromLocal(key, game);
        setEnabled(flag);
        return data;
    }
}

export default Storage;
